import * as React from "react";
import { targetFilterRowStyles } from "./styles";
import { Complete } from "components/icons/assortments/complete";
import { LookUpFieldMap, SingleLineLookupFields } from "helpers/merchant/lookup/single-line-lookup-fields";
import { AllocationBag, AllocationBagType, getAllocationBagPath } from "helpers/allocation-dimension";
import { isValidTargetValue } from "./target-values-grid";
import { Metric } from "helpers/metrics/types";
import { metricsNumberFormatter } from "../../../../../../../helpers/metrics/formatters/metrics-number-formatter";

const styles = targetFilterRowStyles();

interface IProps {
    merchantId: string;
    targetId: string;
    lookUpFieldMap: LookUpFieldMap;
    selected: boolean;
    isInError: boolean;
    isComplete: boolean;
    targetAllocationBagBuffer: AllocationBag;
    setSelectedTargetId: (selectedId: string) => void;
    selectedMetrics: Metric | undefined;
}

export const TargetFilterRow: React.FunctionComponent<IProps> = ({
    merchantId,
    targetId,
    lookUpFieldMap,
    selected,
    isInError,
    isComplete,
    targetAllocationBagBuffer,
    setSelectedTargetId,
    selectedMetrics,
}) => {
    const modifierClass = React.useMemo(() => {
        if (selected && isInError) {
            return "containerError";
        } else if (selected) {
            return "selectedContainer";
        }

        return "";
    }, [selected, isInError]);

    const totalForThisTarget = React.useMemo(() => {
        let total = 0;

        const targetBagValues = targetAllocationBagBuffer?.getIn(
            getAllocationBagPath(AllocationBagType.target, targetId)
        );
        if (targetBagValues) {
            targetBagValues.map((valueObj) => {
                const stringValue = valueObj.get("string_value");
                const stringValueNumber = Number(stringValue);
                if (stringValueNumber && isValidTargetValue(stringValue)) {
                    total += stringValueNumber;
                }
            });
        }

        return total;
    }, [targetAllocationBagBuffer, targetId]);

    return (
        <button {...styles} className={`container ${modifierClass}`} onClick={() => setSelectedTargetId(targetId)}>
            <SingleLineLookupFields
                merchantId={merchantId}
                schemaList={lookUpFieldMap[targetId]?.schemaList}
                dependenciesValues={lookUpFieldMap[targetId]?.dependenciesValues}
                fieldRenderer={(text) => (
                    <span className={isInError ? "targetFilterDescriptionErrorText" : "targetFilterDescriptionText"}>
                        {text}
                    </span>
                )}
            />
            {!isInError && isComplete && (
                <div className="statusContainer">
                    <Complete style={{ width: 12, height: 12, position: "absolute", right: 0 }} />
                </div>
            )}
            <span className="totalText">
                {metricsNumberFormatter({
                    kind: selectedMetrics?.kind,
                    numberFormat: selectedMetrics?.numberFormat,
                })(totalForThisTarget)}
            </span>
        </button>
    );
};
